import React, {useState}  from 'react';
import {
  Card,
  CardBody,CardHeader, CardTitle, Table, 
  Modal,
  ModalBody,
 } from "reactstrap";
import { Spinner } from 'components/Icons/Spinner';
import { Link } from 'react-router-dom';
import { CourseEnrollCard } from './CourseEnrollCard';
import { useSelector } from 'react-redux'
var Utils = require ('Utils');
var Const = require ('Const');
var Icons = require ('Icons');

const StudentListCard = ( { personas, isLoading,enroleStudent,unEnroleStudent  } ) =>  {

  const [modalOpen, setModalOpen] = useState(false);
  
  const { course, token } = useSelector(state => ({
    token: state.auth.session.jwt_token, 
    course: state.courses.course
    
   }))

    return (
          <>
          <Modal toggle={() => setModalOpen(!modalOpen)} isOpen={modalOpen}  size="lg">
            <ModalBody >
                  <CourseEnrollCard 
                    enroleStudent={enroleStudent}
                    unEnroleStudent={unEnroleStudent}
                    closeMe={setModalOpen}
                  />
            </ModalBody>
        </Modal>
  
          {(personas && !isLoading) ?
            <Card className="card-tasks">
               <CardHeader>
                  <CardTitle tag="h4">Alumnos 
                        <div className="float-right">
                          <Link to="#"
                            onClick={() => { setModalOpen(!modalOpen)  }}
                          >
                            <i className={Icons.PERSON_ADD} />
                          </Link>
                        </div>
                  </CardTitle>
                 <span>Hay {personas.length} matriculados en este curso</span>
               </CardHeader>
               <CardBody>
                 <div style={{ height: "500px", overflow: "auto", display: "block" } }>
                   <Table className="table table-striped mb-0" >
                     <tbody>

                    { personas.map( ( persona, idx ) => { 
                      return (
                         <tr key={persona.persona_id}>
                            <td className="img-row">
                              <div className="img-wrapper">
                                <img
                                  alt="..."
                                  className="img-raised"
                                  src={persona.image?persona.image:Const.DEFAULT_IMAGE_PROFILE[(persona.gender?persona.gender:'O')]}
                                />
                              </div>
                            </td>
                            <td className="text-left">
                              <Link to={"/admin/students/"+persona.persona_id}>
                                {Utils.capitalize(persona.last_name + ", " + persona.name)}
                              </Link>
                            </td>
                            <td >
                              <Link to="#"
                                onClick={() => { unEnroleStudent(token, course.course_id,persona.persona_id) }}
                              >
                              <i className={Icons.REMOVE} />
                            </Link>
                            </td>
                          </tr>

                         
                          )
                      } ) }

                      </tbody>

                  </Table>
                  </div>
                  </CardBody>
            </Card>                   
          :
          <Spinner size="XL" />
          }
        </>
  
        );
        }

export { StudentListCard } ;
